import { specialists } from "./data";
import { UPDATE } from "./types";



const INITIAL_STATE = {
	doctors: specialists, // 2 - 5
	best:    { // 1
        image: "https://listkit.cssninja.io/img/photo/avatar/8.jpg",
        icon: "https://images.pexels.com/photos/4609046/pexels-photo-4609046.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=750&w=1260",
        name: "Dr. Emilly James",
        specialty: "General Medicine",
        username: "dr-emily-james",
        rating: 5
    },
	featured: specialists // 6 - 25
};

export const reducer = (state = INITIAL_STATE, action) => {
	switch (action.type) {
		case UPDATE:
			return {
				...state,
				...action
			};

		default:
			return state;
	}
};


